import type { Strings } from '../index.ts';

/**
 * Die Kommentare unter einem Video.
 *
 * `replies.noun` füllt `one` und `other` aus, weil Deutsch dieselben zwei CLDR-Kategorien hat wie
 * Englisch. Ausgewählt wird auf der **Zahl**, nie auf dem verkürzten Label.
 */
export const comments: Strings['comments'] = {
  heading: 'Kommentare',
  headingWithCount: (count) => `${count} Kommentare`,

  sort: {
    top: 'Top-Kommentare',
    new: 'Neueste zuerst',
  },

  replies: {
    hide: 'Antworten ausblenden',
    show: 'Antworten anzeigen',
    count: (count) => count,
    showMore: 'Weitere Antworten anzeigen',
    showMoreCount: (count) => `${count} weitere anzeigen`,
    noun: { one: 'Antwort', other: 'Antworten' },
  },

  notice: {
    sortFallback:
      'Die Top-Kommentare konnten für dieses Video nicht geladen werden, deshalb stehen hier die neuesten.',
    sortFallbackTruncated: (shown, total) =>
      `Die Top-Kommentare konnten für dieses Video nicht geladen werden, deshalb stehen hier die ${shown} neuesten von ${total}.`,
    truncated: (shown, total) => `Es werden ${shown} von ${total} gezeigt.`,
    unknownTotal: '?',
  },

  failure: {
    upstreamBroken:
      'Die Kommentare zu diesem Video konnten nicht von YouTube geladen werden. Ein neuer Versuch hilft nicht.',
    errorRetryable: 'Die Kommentare konnten nicht geladen werden. Die Instanz ist vielleicht beschäftigt.',
    error: 'Die Kommentare konnten nicht geladen werden.',
  },

  empty: {
    live: 'Livestreams haben einen Chat statt Kommentaren, und Visious zeigt ihn nicht.',
    disabled: 'Kommentare sind für dieses Video abgeschaltet.',
    unreadable:
      'Die Kommentare zu diesem Video konnten nicht geladen werden. Das heißt nicht, dass es keine gibt.',
    none: 'Noch keine Kommentare.',
  },
};
